import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { ProductPicker } from '@reveni-io/reveni-ui'

import AppContext from '@/context/AppContext'
import { needsRefund } from '@/helpers'

import useRecommendations from './hooks/useRecommendations/useRecommendations'
import * as Styles from './styles'

const ProductsRecommendations = () => {
  const { context } = useContext(AppContext)
  const { t } = useTranslation()
  const { show, loading, recommendations, showViewMore, handleGetMoreProducts } = useRecommendations({
    orderId: context.orderInfo.id,
    itemId: context?.items?.[0]?.id,
    needsRefund: needsRefund(context?.orderAmount?.remaining_amount),
    orderStatus: context?.orderInfo?.status,
    refundOnHold: context?.orderInfo?.refund_on_hold,
  })

  const handleSelectProduct = product => {
    window.open(product.url, '_blank')
  }

  if (show && recommendations?.results?.length > 0) {
    return (
      <Styles.ProductsRecommendationsContainer>
        <p>{t('Ahora que ya tienes tu reembolso, no te quedes con las ganas de comprar el producto que te gusta')}:</p>
        <ProductPicker
          products={recommendations?.results}
          loading={loading}
          options={{ showSearchInput: false, showStoreLink: false, showViewMore }}
          merchantUrl={`https://${context?.merchantInfo?.domain}`}
          onSelectProduct={handleSelectProduct}
          onGetMoreProducts={handleGetMoreProducts}
          currency={context?.orderInfo?.summary?.currency}
        />
      </Styles.ProductsRecommendationsContainer>
    )
  }

  return null
}

export default ProductsRecommendations
